module.exports = __webpack_public_path__ + "img/2.2b3fe645.svg";